import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/main.scss';

fetch('/config.json')
  .then((res) => res.json())
  .then((data) => {
    // TODO: Find a better method of loading GTM from <head>. Suggest SSR index.html
    /* eslint-disable */
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', data.GA.account);
    /* eslint-enable */

    window.ntConfig = data;
    console.log('ntConfig loaded. Rendering all apps...');
    const container = document.getElementById('root');
    const root = createRoot(container);
    root.render(<App ntConfig={data} />);
  })
  .catch((err) => console.error(err));
